import buildLocalizeFn from '../../../_lib/buildLocalizeFn/index';

function ordinalNumber(dirtyNumber, dirtyOptions) {
  const number = Number(dirtyNumber);

  const rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'ya kwanza';
      case 2:
        return number + 'ya pil';
      case 3:
        return number + 'ya tatu';
    }
  }
  return number + 'ya tatu';
}

const eraValues = {
  narrow: ['Kabla', 'Baada'],
  abbreviated: ['Kabla ya Kristo', 'Baada ya Kristo'],
  wide: ['Kabla ya Kristo', 'Baada ya Kristo'],
};

const quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Robo ya 1', 'Robo ya 2', 'Robo ya 3', 'Robo ya 4'],
  wide: ['Robo ya kwanza', 'Robo nusu', 'Robo ya tatu', 'Robo ya nne'],
};

const monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: [
    'Jan',
    'Feb',
    'Mac',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Ago',
    'Sep',
    'Okt',
    'Nov',
    'Des',
  ],
  wide: [
    'Januari',
    'Februari',
    'Machi',
    'Aprili',
    'Mei',
    'Juni',
    'Julai',
    'Agosti',
    'Septemba',
    'Oktoba',
    'Novemba',
    'Desemba',
  ],
};

const dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: [
    'Jumapili',
    'Jumatatu',
    'Jumanne',
    'Jumatano',
    'Alhamisi',
    'Ijumaa',
    'Jumamosi',
  ],
  abbreviated: [
    'Jumapili',
    'Jumatatu',
    'Jumanne',
    'Jumatano',
    'Alhamisi',
    'Ijumaa',
    'Jumamosi',
  ],
  wide: [
    'Jumapili',
    'Jumatatu',
    'Jumanne',
    'Jumatano',
    'Alhamisi',
    'Ijumaa',
    'Jumamosi',
  ],
};

const dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'asubuhi',
    afternoon: 'mchana',
    evening: 'jioni',
    night: 'usiku',
  },
  abbreviated: {
    am: 'asubuhi',
    pm: 'mchana',
    midnight: 'usiku wa manane',
    noon: 'mchana',
    morning: 'asubuhi',
    afternoon: 'mchana',
    evening: 'jioni',
    night: 'usiku',
  },
  wide: {
    am: 'asubuhi',
    pm: 'mchana',
    midnight: 'usiku wa manane',
    noon: 'mchana',
    morning: 'asubuhi',
    afternoon: 'mchana',
    evening: 'jioni',
    night: 'usiku',
  },
};

const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide',
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    },
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide',
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide',
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
  }),
};

export default localize;
